import { useMemo } from 'react';

import { useNavigationStructure } from './Context';

export function useContentRoutes(path: string | null = null) {
  const nav = useNavigationStructure();

  return useMemo(() => nav.getChildItems(path), [nav, path]);
}
